module.exports = __webpack_public_path__ + "static/media/callring.7cd58d56.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/callring.mp3
// module id = 809
// module chunks = 0